/* NeuroVision: the add-on switch, the same one the Course Pack and Jaw and Body have (here it offers the
   Course Pack itself, snippets/nv-addon.liquid). A copy of assets/jbc-addon.js, code unchanged.

   This is assets/cpk.js section 1 (Course Pack V2). The function below is copied from it without edit,
   so the switch behaves here exactly as it does there. In its comments "the Course Pack" means the page's
   own product, here NeuroVision.

   assets/cpk.js itself is not loaded on this template: its section 2 binds the top bar's Buy Now, which
   this page already binds in its own nv_header_buy section, and two binders on one tap would add twice.

   Loaded only by this template's nv_addon_assets section. It shows and hides elements and enables and
   disables the add-on's own controls. It never reads or writes this product's form, its variant, its
   quantity, its Add to cart, its payment buttons, the cart or checkout. */
(function () {
  'use strict';
  if (window.pproCpkAddonLoaded) { return; }
  window.pproCpkAddonLoaded = true;

  function wire(scope) {
    var addon = scope.querySelector('.fah2__addon');
    if (!addon || addon.dataset.cpkAddonReady) { return; }
    var toggle = addon.querySelector('[data-fah2-addon-toggle]');
    var buy = addon.querySelector('.fah2__addon-buy');
    if (!toggle || !buy) { return; }
    addon.dataset.cpkAddonReady = '1';

    /* WHEN THE SWITCH IS OFF THE ADD-ON CANNOT BE BOUGHT, BY TWO MEANS, NOT ONE.

       hidden plus the [hidden] rule in assets/cpk-addon.css takes the controls off the
       page, so nothing is presented as though the Method is being added. On its own that
       is only a presentation guarantee: the form is still in the document, and a rule
       that set a display on .fah2__addon-buy, or anything that submitted the form
       programmatically, would defeat it silently.

       So the controls are also disabled while the switch is off. A disabled control is
       not submitted by the browser at all, which makes the add-on genuinely inactive
       rather than merely invisible, and it is restored the moment the switch goes on.

       Only the add-on's OWN controls are touched, inside its own box. Nothing here reads
       or writes the Course Pack's form, its variant, its quantity, its Add to cart, its
       payment buttons, the cart or checkout. */
    var ownControls = buy.querySelectorAll('input, select, textarea, button');

    /* WHILE THE SWITCH IS ON THERE IS EXACTLY ONE WAY TO BUY.

       With the switch on, the Course Pack's own Add to cart and Buy it now are taken off
       the page, so the only purchase controls on screen are the Method's. Turning the
       switch off brings them straight back. Master asked for this repeatedly; it is the
       behaviour the component was approved with on the Functional Activator and the
       behaviour snippets/cpk-addon.liquid describes.

       Hiding the host's <product-form> is the whole of it. The theme puts the quantity,
       Add to cart and the dynamic checkout buttons inside that one element and keeps the
       price and everything else OUTSIDE it, so nothing else moves. The add-on's own form
       is a plain <form>, so it can never match, and the filter below excludes it anyway.

       Scoped to the product component this box sits in, never the document, so the
       Featured Product section lower down the page is not reached.

       data-cpk-addon-hidden is what assets/cpk-addon.css answers, because the hidden
       attribute alone loses to the theme's own .product-form { display: block }.

       Presentation only. It never reads or writes a form's values, a variant, the
       quantity, Add to cart, a payment button, the cart or checkout, and a hidden form
       is never submitted. */
    /* Which buy controls this add-on switches off.

       In the buy column the add-on sits inside <product-page>, so that is the scope.
       The Featured Product section lower down the page has no <product-page> and cannot
       hold a custom liquid block, so its add-on is a section of its own, placed directly
       after it. In that case the scope is the nearest earlier section that actually
       contains a <product-form>, which is the Featured Product itself. Without this the
       switch would hide nothing there and the page would show two ways to buy at once,
       which is the thing that was fixed on 2026-10-06.

       It never searches the whole document: it walks back through sibling sections only,
       and stops at the first one with a product form. */
    var host = addon.closest('product-page');
    if (!host) {
      var own = addon.closest('.shopify-section');
      if (own && own.querySelector('product-form')) {
        host = own;
      } else if (own) {
        var prev = own.previousElementSibling;
        while (prev) {
          if (prev.querySelector && prev.querySelector('product-form')) { host = prev; break; }
          prev = prev.previousElementSibling;
        }
        if (!host) { host = own; }
      }
    }

    function hostControls() {
      if (!host) { return []; }
      var forms = host.querySelectorAll('product-form');
      var out = [];
      for (var f = 0; f < forms.length; f++) {
        if (!addon.contains(forms[f])) { out.push(forms[f]); }
      }
      return out;
    }

    function sync() {
      var on = !!toggle.checked;
      addon.classList.toggle('is-on', on);
      if (on) { buy.removeAttribute('hidden'); } else { buy.setAttribute('hidden', ''); }
      for (var c = 0; c < ownControls.length; c++) {
        ownControls[c].disabled = !on;
      }
      var hosts = hostControls();
      for (var i = 0; i < hosts.length; i++) {
        if (on) {
          hosts[i].setAttribute('hidden', '');
          hosts[i].setAttribute('data-cpk-addon-hidden', '');
        } else {
          hosts[i].removeAttribute('hidden');
          hosts[i].removeAttribute('data-cpk-addon-hidden');
        }
      }
    }
    toggle.addEventListener('change', sync);
    sync();

    /* The add-on's own quantity.

       Recovered from assets/fa-product-page.js at commit 8a47026, where it worked. It
       was deleted with the Activator's add-on in ff9b7f3, which left these two buttons
       on the Course Pack page with nothing listening to them: the page rendered them,
       they looked live, and clicking did nothing.

       It types a number into the add-on form's OWN native quantity field, name="quantity",
       which is what Shopify's /cart/add already reads. Bounds are the same 1 and 99 that
       implementation used.

       It does nothing else. No cart call, no submit, no variant, and it never reads or
       writes the Course Pack's form, its variant, its quantity, its Add to cart, its
       payment buttons, the cart or checkout. Scoped inside this add-on box. */
    var qtyField = addon.querySelector('.fah2__addon-buy input[name="quantity"]');
    var qtyButtons = addon.querySelectorAll('[data-fah2-addon-qty]');
    for (var q = 0; q < qtyButtons.length; q++) {
      bindQty(qtyButtons[q], qtyField);
    }
  }

  function bindQty(btn, qtyField) {
    btn.addEventListener('click', function () {
      if (!qtyField) { return; }
      var step = parseInt(btn.getAttribute('data-fah2-addon-qty'), 10) || 0;
      var next = (parseInt(qtyField.value, 10) || 1) + step;
      qtyField.value = Math.max(1, Math.min(99, next));
    });
  }

  function init() {
    var scopes = document.querySelectorAll('[data-cpk-addon]');
    for (var i = 0; i < scopes.length; i++) { wire(scopes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
